import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import { A11y, Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import MarketplaceCard from '../MarketplaceCard';
import { SELLER_REVIEWS } from './sellerReviews';

const ROTATION_INTERVAL_MS = 5000;
const FADE_DURATION_MS = 300;
const STAR_POSITIONS = [0, 1, 2, 3, 4];

const SellerReviewsCard = () => (
  <MarketplaceCard header="What sellers are saying">
    <Box
      px={{ base: '18px', md: '24px' }}
      py="20px"
      sx={{
        '--swiper-pagination-color': 'var(--chakra-colors-leaseEndYellow)',
        '--swiper-pagination-bullet-inactive-color': 'var(--chakra-colors-grayMediumBackground)',
        '--swiper-pagination-bullet-inactive-opacity': '1',
        '.swiper': { paddingBottom: '28px' },
        '.swiper-wrapper': { alignItems: 'center' },
        '.swiper-slide': { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
      }}
    >
      <Swiper
        modules={[A11y, Autoplay, EffectFade, Pagination]}
        effect="fade"
        fadeEffect={{ mode: 'cross-fade' }}
        speed={FADE_DURATION_MS}
        rewind
        autoplay={{
          delay: ROTATION_INTERVAL_MS,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        }}
        pagination={{ clickable: true }}
        a11y={{ containerMessage: 'Seller reviews', itemRoleDescriptionMessage: 'review' }}
      >
        {SELLER_REVIEWS.map((review) => (
          <SwiperSlide key={review.reviewerFirstName}>
            <HStack spacing="2px" mb="10px">
              {STAR_POSITIONS.map((position) => (
                <Icon
                  as={FaStar}
                  key={position}
                  boxSize="13px"
                  color={position < review.rating ? 'leaseEndYellow' : 'grayMediumBackground'}
                />
              ))}
            </HStack>
            <Text fontSize="13.5px" color="charcoal" lineHeight="1.55">
              &ldquo;{review.quote}&rdquo;
            </Text>
            <Text fontSize="12.5px" color="grayLight" mt="14px">
              {review.reviewerFirstName} on {review.source}
            </Text>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  </MarketplaceCard>
);

export default SellerReviewsCard;
